import { SpGroupType } from '@/utils/hooks/swr/group/useSPGroups';
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import {
    useGlobalInfo,
    TOGGLE_MENU_SELECTED_GROUP_OPEN
} from '@/utils/hooks/context/useGlobalInfo';

import Icon from '@/components/base/Icon';
import { AvatarMenu } from '@/components/composite/SocialProfiles/Components/AvatarMenu';
import { SocialProfilesMenuMobileContent } from '@/components/composite/SocialProfiles/SocialProfileGroupMenuMobile/Components/MenuContent/SocialProfiles';

type GroupMenuMobileProps = { group: SpGroupType; toggleSideBar: () => void };
export function GroupMenuMobile({ group, toggleSideBar }: GroupMenuMobileProps) {
    const { setActiveSocialProfile } = useActiveSocialProfile();
    const { dispatch, globalInfo } = useGlobalInfo();

    return (
        <div className="flex flex-col space-y-5" data-testid="social-inbox-mobile-menu-group">
            <button
                data-testid="back-button"
                onClick={() => dispatch({ type: TOGGLE_MENU_SELECTED_GROUP_OPEN, payload: false })}
                className="mx-6 flex items-center space-x-3 rounded-md border-2 border-icoGray-300 bg-white p-3 dark:border-icoDarkMode-beton dark:bg-icoDarkMode-deepBlack">
                <Icon
                    icon="chevron-left"
                    className="text-xl text-icoGray-500 dark:text-icoDarkMode-wolf"
                />
                <AvatarMenu
                    data={group}
                    variant="group"
                    compact={false}
                    additionalInfosSize="small"
                />
            </button>
            <SocialProfilesMenuMobileContent
                variant="group"
                toggleSideBar={toggleSideBar}
                itemsList={group.social_profiles?.filter((socialProfile) => socialProfile.active)}
                setActiveItem={setActiveSocialProfile}
                activeItem={globalInfo.group.activeSocialProfile}
            />
        </div>
    );
}
